module.exports = __webpack_public_path__ + "static/media/homem_r2_c6.2fbf06ef.jpg";